
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sourcing/products/[handle]/[[...device]]",
      function () {
        return require("private-next-pages/sourcing/products/[handle]/[[...device]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sourcing/products/[handle]/[[...device]]"])
      });
    }
  